// @ts-nocheck
import '@/support/styles/record-detail.scss';
import { defineComponent, reactive, onBeforeMount, ref } from 'vue';
import { useRoute } from "vue-router";
import { useLoading } from "@/support/hooks/useLoading";
import { PayRecordSearchVO } from "@/declares/vo/payCenter/PayRecordSearchVO";
import { payRecordApi } from "@/apis/payCenter/payRecordApi";
import PayRecordInfoCard from './payRecord.[flowNo]/payRecordInfoCard';
import PayRecordParams from './payRecord.[flowNo]/payRecordParams';
import PayRecordNotifyRecords from './payRecord.[flowNo]/payRecordNotifyRecords';
import { notifyBizRecordApi } from "@/apis/payCenter/notifyBizRecordApi";
import { NotifyBizRecordDO } from "@/declares/entity/payCenter/NotifyBizRecordDO";
import { message } from '@/support/util/message';
import { msgOnErr } from '@/support/util/catchMsg';

function PayRecordDetail() {
  const route = useRoute();
  const loadModelLoading = useLoading();
  const tab = ref('params');
  const notifyRecords = ref([] as NotifyBizRecordDO[]);
  const model = reactive(new PayRecordSearchVO());
  onBeforeMount(() => loadRecord());


  /**
   * 加载数据
   */
  const loadRecord = loadModelLoading.wrap(async () => {
    const flowNo = route.params.flowNo as string;
    const res = await payRecordApi.findByFlowNo(flowNo);
    Object.assign(model, res);
    loadNotifyRecords(model.flowNo);
  });

  /**
   * 加载数据
   */
  async function loadNotifyRecords(flowNo: string) {
    if (flowNo && flowNo.length) {
      const res = await notifyBizRecordApi.findByFlowNo(flowNo);
      notifyRecords.value = res.rows;
    }
  }

  /**
   * 手动发起业务回调
   */
  const manualNotify = msgOnErr(async () => {
    await payRecordApi.manualNotify(model.flowNo);
    message.success('操作成功');
    loadNotifyRecords(model.flowNo);
  });


  /**
   * render
   */
  return () => <div class="biz-page">
    <biz-page-header title="支付记录详情" desc="查看某条支付记录详细数据">
      <div>
        <el-button size="mini" type="primary" onClick={manualNotify}>发起业务回调</el-button>
        <el-button icon="el-icon-refresh" size="mini" onClick={loadRecord}>刷新</el-button>
      </div>
    </biz-page-header>
    <div class="record-detail">
      <pay-record-info-card model={model} onClickRefresh={loadRecord} />
      <div class="record-detail-main">
        <el-tabs type="card" model-value={tab.value}>
          <el-tab-pane name="params" label="支付参数">
            <pay-record-params model={model} />
          </el-tab-pane>
          <el-tab-pane name="notifyRecords" label="业务回调记录">
            <pay-record-notify-records records={notifyRecords.value} />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
}


export default defineComponent({
  components: { PayRecordInfoCard, PayRecordParams, PayRecordNotifyRecords },
  setup: PayRecordDetail
});
